module.exports = __webpack_public_path__ + "00fabcbae5f4d0e9d7a5ba9e7466fcee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-9.png
// module id = 3144
// module chunks = 0